import(/* webpackMode: "eager" */ "/builds/crehana-team/frontend/crehana-frontend-apps/apps/talent/src/app/page.tsx")